"use client";

import { Plus, ArrowUpRight } from "lucide-react";

/**
 * Site footer — contact + nav + social columns and copyright.
 */
const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Books", href: "/books" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

const SOCIAL_LINKS = [
  { label: "YouTube", href: "https://www.youtube.com/@burakozgurmd" },
  { label: "Instagram", href: "https://instagram.com/burakozgurmd" },
  { label: "Facebook", href: "https://facebook.com/BurakOzgurMD" },
  { label: "TikTok", href: "https://tiktok.com/@burak.ozgur.md" },
];

export default function Footer() {
  return (
    <footer className="bo-footer">
      <div className="bo-footer-inner">
        <div className="bo-footer-bottom">
          <div className="bo-footer-contact">
            <a href="mailto:contact@ozgurmd.com" className="bo-footer-email">
              <Plus size={16} aria-hidden />
              <span>contact@ozgurmd.com</span>
            </a>
          </div>

          <div className="bo-footer-col">
            <div className="bo-footer-col-label">Navigation</div>
            <ul>
              {NAV_LINKS.map((item) => (
                <li key={item.href}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="bo-footer-col">
            <div className="bo-footer-col-label">Social</div>
            <ul>
              {SOCIAL_LINKS.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{item.label}</span>
                    <ArrowUpRight size={16} aria-hidden />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="bo-footer-copyright">
          <span className="bo-footer-copyright-left">
            &copy; {new Date().getFullYear()} All rights reserved. Burak Ozgur
          </span>
          <a
            href="https://adlensdigital.com"
            target="_blank"
            rel="noopener noreferrer"
            className="bo-footer-copyright-right"
          >
            Powered by Lens
            <ArrowUpRight size={14} aria-hidden />
          </a>
        </div>
      </div>
    </footer>
  );
}
